/**
 * Resolves the API base URL that the Ricoh chat client should use.
 *
 * This helper centralizes the logic for getting the build-time `VITE_API_URL`,
 * mirrors it to `globalThis.__VITE_API_URL__` when missing, and throws if nothing
 * is configured so that builds fail fast in misconfigured environments.
 */

const normalizeValue = (value?: string) =>
  typeof value === "string" && value.trim().length > 0
    ? value.trim()
    : undefined;

const globalScope =
  typeof globalThis !== "undefined"
    ? (globalThis as typeof globalThis & { __VITE_API_URL__?: string })
    : undefined;

const compileTimeValue = normalizeValue(import.meta.env.VITE_API_URL);
const runtimeValue = normalizeValue(globalScope?.__VITE_API_URL__);

if (compileTimeValue && !runtimeValue && globalScope) {
  globalScope.__VITE_API_URL__ = compileTimeValue;
}

const resolvedApiUrl = runtimeValue ?? compileTimeValue;

if (!resolvedApiUrl) {
  throw new Error(
    "[RicohChatClient] VITE_API_URL is not defined. Set the variable in your `.env` or build pipeline."
  );
}

export const API_BASE_URL = resolvedApiUrl;
